import { IssueStage } from "../services/bug-module/StageType-enum";
export class BugReportDTO{
    public createdBy:string;
    public selectedIssue: string;
    public shortSummary:string;
    public descriptiveSummary:string;
    public photo:string[];
    public status: boolean;
    public bugId:string;
    public stage: IssueStage;
    public treeloLink:string;
    public AdditionalInfo:string;
    public modifiedDate:string;
    public pntComments:string;
    public id:string;
    public createdByName:string;
    public createdByImage:string;

    constructor(){
        this.selectedIssue="";
        this.selectedIssue="";
        this.shortSummary="";
        this.descriptiveSummary="";
        this.photo=null;
        this.status=false;
        this.bugId="";
        this.stage;
        this.treeloLink="";
        this.AdditionalInfo="";
        this.modifiedDate="";
        this.pntComments="";
        this.id="";
        this.createdByName="";
        this.createdByImage="";
    }
}
